module.exports = __webpack_public_path__ + "img/niu18.9bbbf108.jpg";